/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js' // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.
/**
 * Need to import at least one locale-data with intl.
 */
// import 'intl/locale-data/jsonp/en';

// Promise.try is an ES2025 method not yet implemented by Zone.js's ZoneAwarePromise.
// pdfjs-dist v5+ requires it, so we polyfill it here.
if (typeof (Promise as any).try === 'undefined') {
  ;(Promise as any).try = function <T>(
    this: any,
    fn: (...args: any[]) => T | PromiseLike<T>,
    ...args: any[]
  ): Promise<T> {
    const Constructor = typeof this === 'function' ? this : Promise

    return new Constructor((resolve: (value: T | PromiseLike<T>) => void) => {
      resolve(fn(...args))
    })
  }
}
